module.exports = __webpack_public_path__ + "img/presentation08.09c6f05e.jpg";